var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacherPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 61.585,
    height: 50.08,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(0 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(0 10)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 60.5,
    cy: 60.5,
    r: 60.5,
    fill: "#96999c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(29.56 37.265)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M116.816,39.224c-.259.013-.519.036-.778.036q-16.467,0-32.934,0c-.944,0-.941,0-.495-.825a7.728,7.728,0,0,0,.92-3.811c-.007-.661.028-1.323-.006-1.983a1.036,1.036,0,0,1,.711-1.1c2.814-1.356,5.605-2.76,8.42-4.116.52-.251.632-.484.337-.993a17.265,17.265,0,0,1-.957-1.938c-.18-.425-.364-.462-.764-.263-3.1,1.54-6.218,3.055-9.326,4.586a2.144,2.144,0,0,1-.979.231c-3.486-.006-6.971,0-10.457-.007-.186,0-.444.1-.541-.117-.081-.18.144-.307.247-.446A9.616,9.616,0,0,0,66.6,13.9a1.181,1.181,0,0,1-.8-1.261c.034-3.946.016-7.893.018-11.839,0-.8,0-.8.8-.8H112.77c.791,0,.8.006.8.877q0,16.8,0,33.595c0,1.009,0,1.007,1.025,1.01.741,0,1.482.009,2.223.014Zm-27.1-24.366c-4.106,0-8.212.008-12.318-.01-.512,0-.73.126-.694.672.042.638.009,1.281.01,1.922,0,.841,0,.842.868.842h24.155a2.14,2.14,0,0,1,.24,0c.456.052.66-.12.635-.607-.032-.619-.007-1.241-.007-1.862,0-.958,0-.959-.931-.959H89.712M89.589,10.7c3.083,0,6.166-.009,9.249.009.5,0,.672-.161.651-.655-.032-.739-.039-1.483,0-2.221.031-.551-.2-.677-.7-.666-1.4.028-2.8.01-4.2.01-4.684,0-9.369.009-14.053-.012-.56,0-.741.168-.709.717a16.434,16.434,0,0,1,0,2.1c-.042.6.2.733.759.728,3-.024,6.006-.011,9.009-.011",
    transform: "translate(-55.231 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M15.333,202.01c2.9,0,5.227-.01,7.549.007.614,0,1.391-.266,1.8.141.432.428.117,1.217.155,1.846a4.123,4.123,0,0,1-.106,1.251,4.607,4.607,0,0,1-4.408,3.509c-1.622.015-3.244,0-4.865,0-.839,0-.84,0-.84.868q0,4.535,0,9.07c0,.878,0,.881-.845.881q-6.487,0-12.974,0c-.8,0-.8,0-.8-.8,0-3.223-.007-6.447,0-9.671a7.271,7.271,0,0,1,6.843-7.048c3.023-.119,6.045,0,8.485-.06",
    transform: "translate(0 -169.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M13.033,102.484A6.172,6.172,0,1,1,6.8,108.608a6.192,6.192,0,0,1,6.229-6.124",
    transform: "translate(-5.712 -86.022)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherPlaceholder);
export default __webpack_public_path__ + "static/media/teacher_placeholder.f05c9d0da662671311cd85775d78745c.svg";
export { ForwardRef as ReactComponent };